import { render, staticRenderFns } from "./OpeningHoursEditor.vue?vue&type=template&id=4d7e8b3c&scoped=true&lang=pug&"
import script from "./OpeningHoursEditor.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursEditor.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursEditor.vue?vue&type=style&index=0&id=4d7e8b3c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7e8b3c",
  null
  
)

/* custom blocks */
import block0 from "./OpeningHoursEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports